import { onMounted, onUnmounted, ref } from 'vue';

export function useInView(options?: IntersectionObserverInit) {
  const inView = ref(false);
  const inviewRef = ref<HTMLElement | null>(null);
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    if (inviewRef.value) {
      observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          inView.value = true;
          if (observer && inviewRef.value) {
            observer.unobserve(inviewRef.value);
            observer.disconnect();
            observer = null;
          }
        }
      }, options);
      observer.observe(inviewRef.value);
    }
  });

  onUnmounted(() => {
    if (observer && inviewRef.value) {
      observer.unobserve(inviewRef.value);
      observer.disconnect();
    }
  });

  return { inviewRef, inView };
}
